import { MOKA_SERVICE_HOST } from 'api/constants';

const MOKA_SERVICE_PAYMENT = `${MOKA_SERVICE_HOST}/payment`;

export const PAYMENT_METHODS = `${MOKA_SERVICE_PAYMENT}/v1/payment-methods`;
